export default "__VITE_ASSET__D2wgDwr2__"